import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Security, SecureRoute, LoginCallback as OktaLoginCallback } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { oktaConfig } from './config/oktaConfig';
import WidgetApp from './AccountSelectorWidget';
import LoginCallback from './components/LoginCallback';

const oktaAuth = new OktaAuth(oktaConfig);

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  window.location.replace(toRelativeUrl(originalUri || '/', window.location.origin));
};

function App() {
  return (
    <Router>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <div className="App">
          <Routes>
            <Route path="/login/callback" element={<OktaLoginCallback />} />
            <Route path="/callback" element={<LoginCallback />} />
            <Route path="/" element={<WidgetApp />} />
          </Routes>
        </div>
      </Security>
    </Router>
  );
}

export default App;
